module.exports = __webpack_public_path__ + "img/horno.41eeaf2d.svg";